export enum CardBrand {
  VISA = 'visa',
  DISCOVER = 'discover',
  UNKNOWN = 'unknown',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  DINERS = 'diners',
  JCB = 'jcb',
  UNION_PAY = 'unionpay'
}

export interface CardInfo {
  expMonth: number
  brand: CardBrand
  expYear: number
  lastFour: number | string
  name?: string
}

export enum SubscriptionPlanInterval {
  MONTH = 'month',
  YEAR = 'year'
}

export enum SubscriptionStatus {
  CANCELLED = 'CANCELLED',
  SUBSCRIBED = 'SUBSCRIBED',
  PASTDUE = 'PASTDUE',
  PAYMENTDENIED = 'PAYMENTDENIED',
  PROCESSINGCANCEL = 'PROCESSINGCANCEL',
  QUEUEDDOWNGRADE = 'QUEUEDDOWNGRADE',
  TRIALING = 'TRIALING',
  FAILED = 'FAILED',
  INCOMPLETE = 'INCOMPLETE'
}
